import { Button, Menu } from '@material-ui/core';
import CustomRouterLink from 'components/CustomRouterLink/CustomRouterLink';
import { ChevronIcon } from 'components/Icons';
import InvertedChevronIcon from 'components/Icons/InvertedChevronIcon';
import React, { Fragment, useCallback, useMemo, useState } from 'react';
import { topBarMenuItemStyles } from './style';
import TopBarSubMenuItem, { ITopBarSubMenuItem } from './TopBarSubMenuItem';

export interface ITopBarMenuItem {
  label: string;
  path?: string;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
  subItems?: ITopBarSubMenuItem[];
  disabled?: boolean;
}

export default ({
  label,
  path,
  onClick,
  subItems,
  disabled,
}: ITopBarMenuItem) => {
  const classes = topBarMenuItemStyles();
  const [ menuAnchor, setMenuAnchor ] = useState<Element | undefined>();

  const chevronIcon = useMemo(() => {
    if (subItems && subItems.length > 0) {
      return menuAnchor ? <ChevronIcon className={ classes.icon } /> : <InvertedChevronIcon className={ classes.icon } />;
    }
    return null;
  }, [subItems, classes, menuAnchor])

  const openMenu = useCallback((event: React.MouseEvent<HTMLButtonElement>) => {
    setMenuAnchor(event.currentTarget);
  }, [setMenuAnchor])

  const closeMenu = useCallback(() => {
    setMenuAnchor(undefined);
  }, [setMenuAnchor])

  const getMenu = useCallback(() => {
    if (menuAnchor && subItems) {
      return (
        <Menu
          getContentAnchorEl={ null }
          anchorEl={ menuAnchor }
          open={ menuAnchor ? true : false }
          onClose={ () => closeMenu() }
          anchorOrigin={ menuAnchor ? {
            vertical: 'bottom',
            horizontal: 'left',
          } : undefined}
          keepMounted
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
        >
          {
            subItems.map(
              (it: ITopBarSubMenuItem, key: number) => {
                return (
                  <TopBarSubMenuItem
                    { ...it }
                    onClose={ closeMenu }
                    key={ key }
                  />
                )
              }
            )
          }
        </Menu>
      )
    }
  }, [subItems, menuAnchor, closeMenu])

  return (
    <Fragment>
      {
        path ? (
          <Button
            classes={{
              label: classes.labelButton
            }}
            variant="text"
            color="primary"
            endIcon={ chevronIcon }
            component={ CustomRouterLink }
            to={ path }
            onClick={
              (event: any) => {
                if (subItems) {
                  openMenu(event)
                }
                if (typeof onClick === 'function') {
                  onClick(event);
                }
              }
            }
            disabled={ disabled }
          >
            {
              label
            }
          </Button>
          
        ) : (
          <Button
            classes={{
              label: classes.labelButton
            }}
            variant="text"
            color="primary"
            endIcon={ chevronIcon }
            onClick={
              event => {
                if (subItems) {
                  openMenu(event)
                }
                if (typeof onClick === 'function') {
                  onClick(event);
                }
              }
            }
            disabled={ disabled }
          >
            {
              label
            }
          </Button>
        )
      }
      {
        getMenu()
      }
    </Fragment>
  )
}